import React from 'react';
import { Button, Grid, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';
// import CssBaseline from '@material-ui/core/CssBaseline';
// import Topbar from '../components/Topbar';
// import Footer from '../components/Footer';
// import Container from '../components/Div/Container';
// import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';
import { EVENT_IMG } from '../constatns';
// import { FaFileUpload } from 'react-icons/fa';
const styles = (theme) => ({
  body: {
    fontSize: '1.2em',
    lineHeight: 1.7,
    '& span': {
      // color: 'red',
      fontWeight: 'bold',
    },
  },

  importantDatesDiv: {
    // borderRadius: 0,
    borderRadius: '5px',
    color: '#fff',
    // boxShadow: 'none',
    padding: theme.spacing(5, 6),
    height: '100%',
  },
  importantDatesDate: {
    fontWeight: 'bold',
    fontSize: '1.6em',
  },
  importantDatesTitle: {
    fontSize: '1.2em',
  },

  stepsDiv: {
    display: 'flex',
  },
  stepItem: {
    width: '20%',
  },
  stepsNo: {
    fontSize: '1.2em',
    color: '#7d889a',
    '& span': {
      fontSize: '1.2em',
      fontWeight: 'bold',
    },
  },
  stepContent: {
    padding: theme.spacing(3, 4),
    color: '#fff',
    // height: '100%',
  },

  topicTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '1.2em',
    marginBottom: '0.5em',
  },
  topicContents: {
    '& p': {
      paddingLeft: 8,
      textIndent: -8,
    },
  },

  orderedList: {
    '& li': { marginBottom: 10, fontWeight: 500, fontSize: '1.2em', lineHeight: 1.7 },
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    color: '#000000',
    '& th': { textAlign: 'center', fontWeight: 'bold' },
    '& td': {
      fontWeight: 500,
      '& p': {
        textIndent: '-0.65em',
        paddingLeft: '0.6em',
      },
    },
    '&:nth-of-type(odd)': {
      '& th': {
        backgroundColor: '#cfdae6',
      },
      '& td': {
        backgroundColor: '#e6edf6',
      },
    },
    '&:nth-of-type(even)': {
      '& th': {
        backgroundColor: '#e9eff5',
      },
      '& td': {
        backgroundColor: '#f4f7fa',
      },
    },
  },
}))(TableRow);

class FreePaperGuideEn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.stepNoRef = React.createRef();
    this.stepContentRef = React.createRef();
  }

  componentDidMount() {
    for (let i = 1; i <= 5; i++) {
      document.getElementById(`steps-content-${i}`).style.height = `${document.getElementById(`steps-content-1`).scrollHeight}px`;
    }
  }

  stepsForSubmission() {
    const { classes } = this.props;
    const STEPS = [
      {
        no: 1,
        color: '#7d889a',
        bgColor: 'rgba(125,136,154, 0.1)',
        title: 'Sign-up or Log in',
        content: 'If you are already signed-up on this website, you can use the account for your abstract Submisson.',
      },
      {
        no: 2,
        color: '#265c7a',
        bgColor: 'rgba(38, 92, 122, 0.1)',
        title: 'Submit your abstract',
        content: 'Fill out author and abstract information and click the save button.',
      },
      {
        no: 3,
        color: '#0c7282',
        bgColor: 'rgba(12,114,130, 0.1)',
        title: 'Confirmation Letter',
        content: 'After your abstract Submisson,<br/>a confirmation letter will be sent to you via e-mail.',
      },
      {
        no: 4,
        color: '#7fb46d',
        bgColor: 'rgba(127,180,109, 0.1)',
        title: 'My Page',
        content: 'To review or modify your submitted abstracts, visit ‘My Page’ until the submission deadline.',
      },
      {
        no: 5,
        color: '#d0d24d',
        bgColor: 'rgba(208,210,77, 0.1)',
        title: 'Acceptance Notification',
        content: 'An acceptance notification will be sent to you via e-mail.',
      },
    ];

    return (
      <div className={classes.stepsDiv}>
        {STEPS.map((step, idx) => (
          <div key={`step-for-submission-${idx}`} className={classes.stepItem}>
            <div
              className={classes.stepsNo}
              style={{
                backgroundColor: step.bgColor,
                position: 'relative',
                padding: this.props.theme.spacing(2, 0),
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-around',
              }}
              id={`steps-no-${idx + 1}`}
            >
              <p style={{ backgroundColor: step.color, width: '1em', height: '0.3em', position: 'absolute', bottom: '20%', left: 0 }} />
              <div>
                Step <span style={{ color: step.color }}>0{idx + 1}</span>
              </div>
              <img src={`${EVENT_IMG}/submission_step_${step.no}.png`} style={{ height: '2.5em' }} alt="" />
            </div>
            <div className={classes.stepContent} style={{ backgroundColor: step.color }} id={`steps-content-${idx + 1}`}>
              <Typography style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{step.title}</Typography>
              <div style={{ marginTop: '0.5em', paddingBottom: '3em' }}>
                <span style={{ fontSize: '1.1em', lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: step.content }} />
              </div>
              {/* <Typography style={{ fontSize: '1.1em', marginTop: '0.5em', paddingBottom: '1em' }}>{step.content}</Typography> */}
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <React.Fragment>
        <div>
          {/* <h3>Will be Updated</h3> */}
          <Grid container direction="row" alignItems="center">
            <SubTitle>Abstract Submission</SubTitle>
          </Grid>
          <Typography className={classes.body}>
            The KSPRS 2022 organizing committee cordially invites you to submit Free Paper.
            <br />
            All Abstracts must be submitted online via “Abstract Submission” through the website no later than 
            <span style={{ color: 'red' }}>23:59 pm, August 26 (Fri), 2022 (KST).</span>
            <br />
            Submitted abstracts can be revised on the website during the abstract submission period. Submitted abstracts will be reviewed by
            the Academic Affairs Committee of KSPRS.
            <br />
            Accepted abstracts will be presented as oral presentations or E-posters and will be published in the abstract book.
            <br />
            <span style={{ color: this.props.theme.palette.primary.main }}>
              Please read the guidelines carefully before submitting your abstracts.
            </span>
          </Typography>

          <div style={{ textAlign: 'center', marginTop: '1em' }}>
            <Button
              variant="contained"
              // color="primary"
              // disableElevation
              onClick={() => this.props.moveToSubmission()}
              style={{
                borderRadius: '5px',
                backgroundColor: '#164273',
                color: '#fff',
                fontSize: '1.4em',
                fontWeight: 700,
                padding: '1em 0',
                textTransform: 'none',
                width: '300px',
              }}
              // startIcon={<FaFileUpload size={30} />}
            >
              Abstract Submission
            </Button>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Important Dates</SubTitle>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#7d889a' }}>
                <Typography className={classes.importantDatesTitle}>Deadline for Abstract Submission</Typography>
                <Typography className={classes.importantDatesDate}>August 26 (Fri), 2022</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#265c7a' }}>
                <Typography className={classes.importantDatesTitle}>Notification of Abstract Acceptance</Typography>
                <Typography className={classes.importantDatesDate}>September 8 (Thu), 2022</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#164273' }}>
                <Typography className={classes.importantDatesTitle}>Deadline for Presenter Registration</Typography>
                <Typography className={classes.importantDatesDate}>October 31 (Mon), 2022</Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Steps for Submission</SubTitle>
          {this.stepsForSubmission()}
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Abstract Topic</SubTitle>
          <Grid container spacing={1}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#265c7a',
                        color: '#fff',
                        fontSize: '1.2em',
                        borderRight: '1px solid #fff',
                        fontWeight: 'bold',
                      }}
                    >
                      Reconstruction
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#869e53',
                        color: '#fff',
                        fontSize: '1.2em',
                        borderleft: '1px solid #fff',
                        fontWeight: 'bold',
                      }}
                    >
                      Aesthetic
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#e9eef1',
                        color: '#000000',
                        // fontWeight: 'bold',
                        fontSize: '1.2em',
                        lineHeight: 1.6,
                        borderRight: '1px solid #fff',
                      }}
                    >
                      <p>- Basic Research</p>
                      <p>- Pediatric / Craniofacial</p>
                      <p>- Hand & Upper Limb Reconstruction</p>
                      <p>- Head and Neck Reconstruction</p>
                      <p>- Breast / Body Reconstruction</p>
                      <p>- Lower Limb Reconstruction</p>
                      <p>- Lymphedema</p>
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#e9eef1',
                        color: '#000000',
                        // fontWeight: 'bold',
                        fontSize: '1.2em',
                        lineHeight: 1.6,
                        borderleft: '1px solid #fff',
                      }}
                    >
                      <p>- Eyelid and Periocular Surgery</p>
                      <p>- Rhinoplasty</p>
                      <p>- Anti-aging Surgery</p>
                      <p>- Facial Contouring Surgery</p>
                      <p>- Aesthetic Breast Surgery</p>
                      <p>- Body Contouring Surgery</p>
                      <p>- Botox, Filler, Minimally Invasive Surgery</p>
                      <p>- Laser</p>
                      <p>- Fat and Stem Cell Therapy</p>
                      <p>- Hair</p>
                      <p>- Other Plastic Surgery</p>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* <Grid item xs={4}>
              <Typography className={classes.topicTitle}>Reconstruction</Typography>
              <div className={classes.topicContents}>
                <p>- Basic Research</p>
                <p>- Pediatric / Craniofacial</p>
                <p>- Hand & Upper Limb Reconstruction</p>
                <p>- Head and Neck Reconstruction</p>
                <p>- Breast / Body Reconstruction</p>
                <p>- Lower Limb Reconstruction</p>
                <p>- Lymphedema</p>
              </div>
            </Grid>
            <Grid item xs={8}>
              <Typography className={classes.topicTitle}>Aesthetic</Typography>
              <div className=+{classes.topicContents} style={{ columnCount: 2, WebkitColumnCount: 2, MozColumnCount: 2 }}>
                <p>- Eyelid and Periocular Surgery</p>
                <p>- Rhinoplasty</p>
                <p>- Anti-aging Surgery</p>
                <p>- Facial Contouring Surgery</p>
                <p>- Aesthetic Breast Surgery</p>
                <p>- Body Contouring Surgery</p>
                <p>- Botox, Filler, Minimally Invasive Surgery</p>
                <p>- Laser</p>
                <p>- Fat and Stem Cell Therapy</p>
                <p>- Hair</p>
                <p>- Other Plastic Surgery</p>
              </div>
            </Grid> */}
          </Grid>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Submission Guidelines</SubTitle>
          <div style={{ backgroundColor: '#f6f6f6', display: 'flex', padding: theme.spacing(3, 4) }}>
            <div
              style={{
                color: '#5d6573',
                fontWeight: 'bold',
                fontSize: '1.5em',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingRight: theme.spacing(3),
                borderRight: '1px solid #7d889a',
              }}
            >
              Abstract Format
            </div>
            <div style={{ color: '#000000', fontSize: '1.1em', lineHeight: 1.6, fontWeight: 'bold', paddingLeft: theme.spacing(3) }}>
              - Title : Max <b style={{ color: 'red' }}>30</b> words
              <br />- Body : Max <b style={{ color: 'red' }}>250</b> words
              <br />- Up to <b style={{ color: 'red' }}>4</b> figures or tables <br />
            </div>
          </div>
          <div style={{ color: '#000000' }}>
            <ol className={classes.orderedList}>
              <li>
                All abstracts must be submitted online via the PRS KOREA 2022 website.
                <br /> Abstract submitted via e-mail, fax or regular mail will neither be accepted nor acknowledged.{' '}
              </li>
              <li>
                All abstracts must be written in clear <span style={{ textDecoration: 'underline' }}>English</span> and submitted with as
                oral or E-poster presentation and prior to <span>23:59 pm, August 26 (Fri), 2022 (KST).</span>
              </li>
              <li>It is the responsibility of the authors to ensure that their text does not contain typos or grammatical errors.</li>
              <li>Abstract titles should be brief and reflecting the content of the abstract.</li>
              <li>
                All articles should contain a brief, clear statement of the background (Purpose, Methods, Results and Conclusion) of your
                work.
              </li>
              <li>
                Abstracts should not exceed <span style={{ textDecoration: 'underline' }}>250 words</span> the submission system will not
                accept anything beyond that.
              </li>
              <li>Authors may further edit and modify submitted abstracts until the submission deadline on MY PAGE.</li>
              <li>
                A confirmation of receipt of abstract will be automatically sent to the submitter, the presenting author and corresponding
                author by e-mail upon their on-line submission. Therefore, please submit the right contact details; otherwise, the presenter
                will not receive important information about his/her presentation.
              </li>
              <li>The right to publish your abstract is granted to the PRS KOREA 2022 Academic Committee.</li>
              <li>
                Abstract submission does not constitute registration for the conference and{' '}
                <b>
                  presenter are required to register for the conference separately and the presenting author must register for the meeting
                  by the end of regular registration,&nbsp;
                </b>
                <span>October 31 (Mon), 2022 (KST).</span>
              </li>
              <li>
                If on-line submission is not possible, please contact the PRS KOREA 2022 Academic Secretariat (
                <strong>
                  <a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>.
                </strong>
                )
              </li>
            </ol>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Structure</SubTitle>
          <div style={{ color: '#000000' }}>
            <ol className={classes.orderedList}>
              <li>An acceptable structure of an abstract must consist of the following components:</li>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#265c7a',
                        color: '#fff',
                        // color: theme.palette.common.white,
                        border: '2px solid #fff',
                        fontWeight: 'bold',
                        fontSize: '1.2em',
                        textAlign: 'center',
                      }}
                    >
                      Purpose
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', fontSize: '1.2em', border: '2px solid #fff' }}>
                      A statement of the hypothesis or research question
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em', fontWeight: 'bold' }}
                    >
                      Methods
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', fontSize: '1.2em' }}>
                      An explanation of the study design and experimental methods used.
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em', fontWeight: 'bold' }}
                    >
                      Results
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff', fontSize: '1.2em' }}>
                      A concise summary of the major findings of the experiment or study. Sufficient data must be provided to permit
                      evaluation by the reviewers and public reading the abstract. Statements such as "the data wil be discussed" are not
                      acceptable.
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em', fontWeight: 'bold' }}
                    >
                      Conclusion
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff', fontSize: '1.2em' }}>
                      Summary of the overall findings and the importance of the study.
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em', fontWeight: 'bold' }}
                    >
                      Remarks*
                      <br />
                      <span style={{ fontSize: '1.0em', color: 'yellow' }}>(Abstract Qualifications)</span>
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#e9eef1',
                        border: '2px solid #fff',
                        fontSize: '1.2em',

                        lineHeight: 1.6,
                      }}
                    >
                      <div>
                        <p>* Topics must reflect some new perspective.</p>
                        <p>* Avoid ongoing studies.</p>
                        <p>* Include final data in your abstract.</p>
                        <p>* Priority is given to specific evidence from a long-term research.</p>
                        <p>
                          * If your paper is about some specific surgical technique, please add some pre-op and post-op and post-op pictures
                          indicating the effect of it.
                        </p>
                        <p>
                          * Please check the list below prior to submission: Please attach a consent form obtained from a patient if a
                          patient photograph is included in your abstract or presentation. (It is the authors' responsibility to obtain
                          consent forms from patients.)
                        </p>
                        <p>* No changes or modifications are allowed in those pictures.</p>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
              <li style={{ marginTop: 10 }}>Corresponding author's contact details: Email address</li>
              <li>Name(s) of presenting author and co-authors: First name(s) or initials of first name(s), family name (e.g. Sam Lee).</li>
              <li>Affiliation details of all authors: Department, Institution/Hospital, City and Country.</li>

              <li style={{ color: 'transparent' }}>
                Affiliation details of all authors:&nbsp;
                <span style={{ color: '#000000', fontWeight: 300 }}>Affiliation(s) should be annotated by superscript numbers.</span>
              </li>
            </ol>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Notification of Acceptance</SubTitle>
          <div style={{ color: '#000000' }}>
            <ol className={classes.orderedList}>
              <li>All submitted abstracts will be reviewed by the Scientific Committee according to standard review procedures.</li>
              <li>
                Notification of acceptance will be sent by e-mail to presenting, corresponding and abstract submitting author by{' '}
                <span>September 8 (Thu), 2022 (KST).</span>
              </li>
            </ol>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Withdrawal of Abstracts</SubTitle>
          <div style={{ color: '#000000' }}>
            <ol className={classes.orderedList}>
              <li>
                If the presenting author of an accepted abstract dose not register{' '}
                <span style={{ textDecoration: 'underline' }}>by the regular registration date</span>, the abstract will be automatically
                withdrawn.
              </li>
              <li>
                If you would like to withdraw an abstract, please notify the PRS KOREA 2022 Academic Secretariat{' '}
                <b>
                  (<a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>)
                </b>{' '}
                in writing as soon as possible.
              </li>
            </ol>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FreePaperGuideEn);
